import type { ModuleOptions } from '@nuxtjs/i18n'
import type { Locale } from 'date-fns'

import { genObjectWithDefaultKey, convertArrayToKeyedObject } from '../utils/common'

export enum LangEnum {
  ENG = 'en',
  TW = 'zh-tw',
  HK = 'zh-hk',
  CN = 'zh-cn',
  THAI = 'th',
  MALAY = 'ms',
}

export const DEFAULT_LANG_CODE = LangEnum.ENG
export const DEFAULT_LANG = 'en-US'

export const supportedLangs: ModuleOptions['locales'] = [
  { name: 'en-US', code: 'en', language: 'en-US', text: 'English', 'iso-abbrev': 'en' },
  { name: 'zh-TW', code: 'zh-tw', language: 'zh-TW', text: '繁體中文', 'iso-abbrev': 'zh' },
  { name: 'zh-HK', code: 'zh-hk', language: 'zh-HK', text: '繁體中文', 'iso-abbrev': 'hk' },
  { name: 'zh-CN', code: 'zh-cn', language: 'zh-CN', text: '简体中文', 'iso-abbrev': 'cn' },
  { name: 'th-TH', code: 'th', language: 'th-TH', text: 'ภาษาไทย', 'iso-abbrev': 'th' },
  { name: 'ms-MY', code: 'ms', language: 'ms-MY', text: 'Bahasa Melayu', 'iso-abbrev': 'ms' },
]

export const HAN_RELATED_LANGS = [LangEnum.TW, LangEnum.CN /* , LangEnum.JP */]

export const supportedLangsByCode = convertArrayToKeyedObject(supportedLangs, 'code')

export const supportedLangsByName = convertArrayToKeyedObject(supportedLangs, 'name')

function genThirdPartyLanguageMap(originMap: Record<string, any>) {
  return genObjectWithDefaultKey(originMap, DEFAULT_LANG_CODE)
}

// locales: https://github.com/date-fns/date-fns/tree/main/src/locale
export const dateFnsLanguageMap: Record<LangEnum, () => Promise<{ default: Locale }>> = genThirdPartyLanguageMap({
  [LangEnum.TW]: () => dynamicImport(() => import('date-fns/locale/zh-TW'), 'date-fns/locale/zh-TW'),
  [LangEnum.CN]: () => dynamicImport(() => import('date-fns/locale/zh-CN'), 'date-fns/locale/zh-CN'),
  [LangEnum.HK]: () => dynamicImport(() => import('date-fns/locale/zh-HK'), 'date-fns/locale/zh-HK'),
  [LangEnum.ENG]: () => dynamicImport(() => import('date-fns/locale/en-US'), 'date-fns/locale/en-US'),
  [LangEnum.THAI]: () => dynamicImport(() => import('date-fns/locale/th'), 'date-fns/locale/th'),
  [LangEnum.MALAY]: () => dynamicImport(() => import('date-fns/locale/ms'), 'date-fns/locale/ms'),
})
